import { actionTypes } from '../actions/skills-lists';
import { skillsLists as defaultState } from './default.json';

const handlers = {
  [actionTypes.SKILLS_LISTS_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    inProgress: false,
  }),
  [actionTypes.SKILLS_LISTS_GET_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.SKILLS_LISTS_GET_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    inProgress: false,
    results: action.results,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
